import {returnSelectedRows} from "../../../../../../../../../../../shared/utils/tableUtils";
import {Checkbox, TableCell, TableRow} from "@material-ui/core";
import {dateConvertedItalianWithFirstCapitalMonth} from "../../../../../../../../../../../shared/utils/dateUtils";
import EmptyRow from "../../../../../../../../../../ui/tables/rows/empty-row/EmptyRow";
import TableWithCheckboxes from "../../../../../../../../../../ui/tables/table-with-checkboxes/TableWithCheckboxes";
import {headCells} from "./SimPrimariaTableHelper";
import PropTypes from "prop-types";
import {useSelector} from "react-redux";

const SimPrimariaTable = (props) => {
    const tableData = useSelector(state => state.ordiniConsipReducer.simPrimariaTable.data);
    const loading = useSelector(state => state.ordiniConsipReducer.simPrimariaTable.loading);
    const handleOnClick = (event, sim) => {
        event.stopPropagation();
        props.setAreAllSelected(false)
        const selectedIndex = props.selected.findIndex(i => i.seriale === sim.seriale);
        props.setSelected(returnSelectedRows(props.selected, sim, selectedIndex));
    };

    const isSelected = (seriale) => props.selected.some(s => s.seriale === seriale);


    const tableRows = (
        tableData.count !== 0 ? tableData.data.map((row, index) => {
            const isItemSelected = isSelected(row.seriale);
            const labelId = `sim-da-attivare-table-${index}`

            return (
                <TableRow
                    hover
                    role="checkbox"
                    aria-checked={isItemSelected}
                    tabIndex={-1}
                    key={row.seriale}
                    onClick={(e) => handleOnClick(e, row)}
                    selected={isItemSelected}>
                    <TableCell padding="checkbox">
                        <Checkbox
                            checked={isItemSelected}
                            onClick={(e) => handleOnClick(e, row)}
                            inputProps={{'aria-labelledby': labelId}}
                        />
                    </TableCell>
                    <TableCell scope="row" padding="none">
                        {row.numeroDiTelefono}
                    </TableCell>
                    <TableCell align="left">{row.seriale}</TableCell>
                    <TableCell>{dateConvertedItalianWithFirstCapitalMonth(row.dataOrdineDiConsegna)}</TableCell>
                    <TableCell>{row.numeroOrdineDiConsegna}</TableCell>
                </TableRow>
            )
        }) : <EmptyRow text="dato" colSpan={headCells.length + 2}/>)

    return (
        <TableWithCheckboxes selected={props.selected}
                             setSelected={props.setSelected}
                             page={props.page}
                             fetchData={props.handlePaginationChange}
                             rowsPerPage={props.rowsPerPage}
                             rows={tableData.data}
                             tableRows={tableRows}
                             headCells={headCells}
                             count={tableData.count}
                             loading={loading}
                             selectAllRows={props.areAllSelected}
                             setSelectAllRows={props.setAreAllSelected}/>
    )
}

SimPrimariaTable.propTypes = {
    page: PropTypes.number.isRequired,
    rowsPerPage: PropTypes.number.isRequired,
    selected: PropTypes.array.isRequired,
    setSelected: PropTypes.func.isRequired,
    areAllSelected: PropTypes.bool.isRequired,
    setAreAllSelected: PropTypes.func.isRequired,
    handlePaginationChange: PropTypes.func.isRequired,
}

export default SimPrimariaTable;